"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var use_translations_hook_1 = __importDefault(require("../../context/translations/use-translations.hook"));
function useLocalization() {
    var getTranslation = use_translations_hook_1.default().getTranslation;
    var weekdays = react_1.useMemo(function () {
        return [
            getTranslation('DATES:SHORT_WEEKDAYS:SUNDAY'),
            getTranslation('DATES:SHORT_WEEKDAYS:MONDAY'),
            getTranslation('DATES:SHORT_WEEKDAYS:TUESDAY'),
            getTranslation('DATES:SHORT_WEEKDAYS:WEDNESDAY'),
            getTranslation('DATES:SHORT_WEEKDAYS:THURSDAY'),
            getTranslation('DATES:SHORT_WEEKDAYS:FRIDAY'),
            getTranslation('DATES:SHORT_WEEKDAYS:SATURDAY'),
        ];
    }, [getTranslation]);
    var months = react_1.useMemo(function () {
        return [
            getTranslation('DATES:MONTHS:JANUARY'),
            getTranslation('DATES:MONTHS:FEBRUARY'),
            getTranslation('DATES:MONTHS:MARCH'),
            getTranslation('DATES:MONTHS:APRIL'),
            getTranslation('DATES:MONTHS:MAY'),
            getTranslation('DATES:MONTHS:JUNE'),
            getTranslation('DATES:MONTHS:JULY'),
            getTranslation('DATES:MONTHS:AUGUST'),
            getTranslation('DATES:MONTHS:SEPTEMBER'),
            getTranslation('DATES:MONTHS:OCTOBER'),
            getTranslation('DATES:MONTHS:NOVEMBER'),
            getTranslation('DATES:MONTHS:DECEMBER'),
        ];
    }, [getTranslation]);
    return [weekdays, months];
}
exports.default = useLocalization;
